import { render, staticRenderFns } from "./SensorsColumn.vue?vue&type=template&id=6720fbe2&scoped=true&"
import script from "./SensorsColumn.vue?vue&type=script&lang=js&"
export * from "./SensorsColumn.vue?vue&type=script&lang=js&"
import style0 from "./SensorsColumn.vue?vue&type=style&index=0&id=6720fbe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720fbe2",
  null
  
)

export default component.exports